;(function () {
  var UK_CODES = ['GB', 'GG', 'JE', 'IM'];
  var EU_EEA = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
    'HU', 'IS', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NL', 'NO', 'PL', 'PT',
    'RO', 'SK', 'SI', 'ES', 'SE', 'CH'
  ];

  function readStoredCountry() {
    try {
      var stored = window.localStorage.getItem('tr_footer_country_code');
      if (stored) return stored;
    } catch (e) {}

    var select = document.querySelector('[data-footer-localization-select], [data-header-localization-select]');
    if (select && select.value) return select.value;

    return '';
  }

  window.trRegionForCountry = function (countryCode) {
    var code = String(countryCode || '').toUpperCase();
    if (!code) return 'uk';

    if (UK_CODES.indexOf(code) !== -1) return 'uk';
    if (code === 'IE') return 'roi';
    if (code === 'US' || code === 'CA') return 'usa_can';
    if (code === 'AU' || code === 'NZ') return 'aus_nz';
    if (EU_EEA.indexOf(code) !== -1) return 'eu_eea';

    return 'row';
  };

  window.trGetEffectiveRegion = function () {
    var country =
      (typeof window.trGetEffectiveCountryCode === 'function' && window.trGetEffectiveCountryCode()) ||
      readStoredCountry() ||
      'GB';

    return window.trRegionForCountry(country);
  };

  function parseRegionTargets(targets) {
    if (!targets) return [];
    if (Array.isArray(targets)) return targets.filter(Boolean);

    return String(targets)
      .split(',')
      .map(function (target) {
        return target.trim();
      })
      .filter(Boolean);
  }

  window.trSlideVisibleForVisitor = function (mode, targets, visitorRegion) {
    var visibilityMode = mode || 'all';
    var targetList = parseRegionTargets(targets);

    if (visibilityMode === 'all' || targetList.length === 0) return true;

    var matches = targetList.indexOf(visitorRegion) !== -1;

    if (visibilityMode === 'include') return matches;
    if (visibilityMode === 'exclude') return !matches;

    return true;
  };

  window.trSlideMatchesRegion = function (slideRegion, visitorRegion) {
    return window.trSlideVisibleForVisitor('include', slideRegion === 'all' ? '' : slideRegion, visitorRegion);
  };

  function getSlideVisibilityConfig(slide) {
    var mode = slide.getAttribute('data-tr-region-mode');
    var targets = slide.getAttribute('data-tr-region-targets') || '';

    if (mode) {
      return { mode: mode, targets: targets };
    }

    var legacyRegion = slide.getAttribute('data-tr-slide-region');
    if (!legacyRegion || legacyRegion === 'all') {
      return { mode: 'all', targets: '' };
    }

    return { mode: 'include', targets: legacyRegion };
  }

  function slideIsVisible(slide, visitorRegion) {
    var config = getSlideVisibilityConfig(slide);
    return window.trSlideVisibleForVisitor(config.mode, config.targets, visitorRegion);
  }

  window.trFilterSlidesByRegion = function (root) {
    var container = typeof root === 'string' ? document.querySelector(root) : root;
    if (!container) return 0;

    var visitorRegion = window.trGetEffectiveRegion();
    var slides = container.querySelectorAll('[data-tr-region-mode], [data-tr-slide-region]');
    var visible = 0;

    slides.forEach(function (slide) {
      if (slideIsVisible(slide, visitorRegion)) {
        slide.classList.add('tr-region-match');
        visible++;
        return;
      }

      slide.remove();
    });

    if (visible === 0) {
      var section = container.closest('[id^="shopify-section"]');
      if (section) section.style.display = 'none';
    }

    return visible;
  };

  window.trMarkSlidesByRegion = function (root) {
    var container = typeof root === 'string' ? document.querySelector(root) : root;
    if (!container) return;

    var visitorRegion = window.trGetEffectiveRegion();

    container.querySelectorAll('[data-tr-region-mode], [data-tr-slide-region]').forEach(function (slide) {
      if (slideIsVisible(slide, visitorRegion)) {
        slide.classList.add('tr-region-match');
      }
    });
  };
})();
